import { useQuery } from "@tanstack/react-query";
import { LabelsService } from "../services/LabelsService";

export const labelKeys = {
  all: ["labels"],
  lists: () => [...labelKeys.all, "list"],
  list: (orgId) => [...labelKeys.lists(), orgId],
  detail: (id) => [...labelKeys.all, "detail", id],
  devices: (id) => [...labelKeys.all, "devices", id],
};

export default function useLabels(organisationId) {
  return useQuery({
    queryKey: labelKeys.list(organisationId),
    queryFn: () => LabelsService.fetchLabels(organisationId),
    enabled: !!organisationId,
  });
}

export function useLabelDevices(labelId) {
  return useQuery({
    queryKey: labelKeys.devices(labelId),
    queryFn: () => LabelsService.fetchLabelDevices(labelId),
    enabled: !!labelId,
  });
}
